<template>
    
    <v-row class="fill-height">
        <v-col>
            <v-card>
                <v-card-title>

                    <v-btn small @click="pushRouteToView('checkout')" class="mr-4 btn-back">
                        <v-icon>
                            mdi-arrow-left
                        </v-icon>
                        Voltar
                    </v-btn>

                    <v-icon left>mdi-cash-fast</v-icon>
                    Checkout
                </v-card-title>
                <v-divider></v-divider>
                <v-alert type="warning" outlined v-show="!checkoutSchedules"
                >Nenhum cliente encontrado
                </v-alert>
                <v-card-text>
                    <v-row class="text-h6">
                        <v-col cols="12" md="7" sm="4" xs="12">
                            <v-icon left>mdi-account-box</v-icon>
                            Cliente: {{ person.name }}
                        </v-col>
                        <v-col cols="12" md="5" sm="4" xs="12">
                            <v-icon left>mdi-phone</v-icon>
                            Telefone: {{ person.phone }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col md="2" sm="12" xs="12">
                            <v-btn @click.prevent="dialogPayment=true; payment()" :disabled="btnPayDisabled"
                                   class="btn-new">
                                <v-icon left>mdi-cash</v-icon>
                                Cobrar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-data-table
                    v-model="selectedIDs"
                    :headers="headers"
                    :items="checkoutSchedules.items"
                    :options.sync="options"
                    :server-items-length="checkoutSchedules.totalItems"
                    item-key="id"
                    class="elevation-1"
                    v-show="checkoutSchedules"
                    :footer-props="{
                        'items-per-page-options': [10, 25, 50, 75, 100]
                      }"
                >

                    <template v-slot:item.payment="{ item }">
                        <v-checkbox
                            v-show="item.statusID == 7 || item.statusID == 8 "
                            v-model="selectedIDs"
                            :value="item.id"
                            :multiple="true"
                            hide-details
                            class="my-2"
                            @click="checkBtnDisable()"
                        ></v-checkbox>
                    </template>

                    <template v-slot:item.totalValue="{ item }">
                        {{ item.totalValue | money }}
                    </template>
                    <template v-slot:item.pendingValue="{ item }">
                        {{ item.pendingValue | money }}
                    </template>


                    <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    class="btn-lyndus"
                                    v-bind="attrs"
                                    v-on="on"
                                    :to="{ name: 'checkoutSchedule', params: { id: id, scheduleID: item.id } }"
                                >
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                            <span>Visualizar</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>

        <v-dialog
            v-model="dialogPayment"
            persistent
            max-width="70%"
        >
            <v-card>
                <v-form
                    ref="formPayment"
                    v-model="formIsValid"
                    v-on:submit.prevent="paymentSave()"
                >
                    <v-card-title>
                        <span class="text-h5">Pagamento</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text v-if="isNewPaymentMethods">
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="6">
                                    <v-card outlined>
                                        <v-card-title class="flex-column">
                                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_26_515)">
                                                <path d="M20.0179 21.2677C17.6047 23.6955 15.8184 26.3776 15.3104 29.7658C15.1729 30.6817 15.2086 31.5869 15.5446 32.4602C16.389 34.6599 18.6384 35.9032 20.9412 35.4484C23.2924 34.985 24.8932 32.9866 24.757 30.5196C24.5514 26.7875 22.5951 23.9158 20.0182 21.2677" fill="#6D59E8"/>
                                                <path d="M8.09067 24.4095C8.96666 24.7449 9.87432 24.7809 10.7929 24.6431C14.1916 24.1351 16.8816 22.3487 19.3169 19.9362C16.661 17.3586 13.7797 15.4024 10.0371 15.1968C7.5633 15.0609 5.55869 16.6614 5.09329 19.0126C4.63844 21.3151 5.88519 23.5648 8.09101 24.4095" fill="#6D59E8"/>
                                                <path d="M34.9067 19.0126C34.4413 16.6614 32.437 15.0609 29.9629 15.1968C26.2203 15.4024 23.3393 17.359 20.6831 19.9362C23.1181 22.3491 25.808 24.1354 29.2071 24.6431C30.1257 24.7809 31.033 24.7449 31.9093 24.4095C34.1151 23.5648 35.3626 21.3151 34.907 19.0126" fill="#6D59E8"/>
                                                <path d="M20.0179 18.732C22.5948 16.0846 24.5511 13.2122 24.7567 9.48075C24.8929 7.0138 23.292 5.01464 20.9409 4.55128C18.6383 4.09745 16.3886 5.34012 15.5443 7.53947C15.2086 8.41342 15.1728 9.31801 15.31 10.2338C15.818 13.6234 17.6044 16.3049 20.0175 18.732" fill="#6D59E8"/>
                                                </g>
                                                <defs>
                                                <clipPath id="clip0_26_515">
                                                <rect width="30" height="31.0833" fill="white" transform="translate(5 4.45837)"/>
                                                </clipPath>
                                                </defs>
                                            </svg>

                                            <span class="text-h6">LyndusPay</span>
                                        </v-card-title>
                                        <div>
                                            <v-tabs 
                                                v-model="lyndusPayment"
                                                color="#6D59E8"
                                                grow>
                                                <v-tab><v-icon left>mdi-credit-card-outline</v-icon> <span class="d-none d-lg-flex">Maquininha</span></v-tab>
                                                <v-tab><v-icon left>mdi-cellphone</v-icon> <span class="d-none d-lg-flex">Aplicativo</span></v-tab>
                                            </v-tabs>
                                            <v-tabs-items v-model="lyndusPayment">
                                                <v-tab-item>
                                                    <v-card>
                                                        <v-card-text>
                                                            <small class="red--text" v-if="!isMethod(7)">
                                                                Método de pagamento indisponível, por favor confira <a href="/financial/accounts">aqui</a> suas contas disponíveis.
                                                            </small>
                                                            <number-input
                                                                outlined
                                                                v-model="lyndusPayMach"
                                                                label="Valor"
                                                                placeholder="Valor"
                                                                :options="optionsMoney"
                                                                dense
                                                                :keyPress="isMethod(7) ? addPaymentNew(isMethod(7),lyndusPayMach) : ''"
                                                                :disabled="!isMethod(7)"
                                                            >
                                                            </number-input>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-tab-item>
                                                <v-tab-item>
                                                    <v-card>
                                                        <v-card-text>
                                                            <small class="red--text" v-if="!isMethod(6)">
                                                                Método de pagamento indisponível, por favor confira <a href="/financial/accounts">aqui</a> suas contas disponíveis.
                                                            </small>
                                                            <number-input
                                                                outlined
                                                                v-model="lyndusPayApp"
                                                                label="Valor"
                                                                placeholder="Valor"
                                                                :options="optionsMoney"
                                                                dense
                                                                :keyPress="isMethod(6) ? addPaymentNew(isMethod(6),lyndusPayApp) : '' "
                                                                :disabled="!isMethod(6)"
                                                            >
                                                            </number-input>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-tab-item>
                                            </v-tabs-items>
                                        </div>
                                        
                                    </v-card>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-card outlined>
                                        <v-card-title class="flex-column">
                                            <v-icon
                                            x-large
                                            >
                                            mdi-cash
                                            </v-icon>
                                            
                                            <span class="text-h6">Dinheiro</span>
                                        </v-card-title>
                                        <div>
                                            
                                            <v-col class="text-center text-uppercase font-weight-medium grey--text text--darken-1">
                                                <v-icon left>mdi-map-marker-outline</v-icon> Estabelecimento
                                            </v-col>

                                            <v-card-text>
                                                <small class="red--text" v-if="!isMethod(3)">
                                                    Método de pagamento indisponível, por favor confira <a href="/financial/accounts">aqui</a> suas contas disponíveis.
                                                </small>
                                                <number-input
                                                    outlined
                                                    v-model="cashPay"
                                                    label="Valor"
                                                    placeholder="Valor"
                                                    :options="optionsMoney"
                                                    dense
                                                    :keyPress="isMethod(3) ? addPaymentNew(isMethod(3),cashPay) : ''"
                                                    :disabled="!isMethod(3)"
                                                >
                                                </number-input>
                    
                                            </v-card-text>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" class="py-1 d-flex flex-column">
                                        <div class="d-flex flex-column">
                                            <strong class="grey--text text--darken-1 text-h6">
                                                {{ totalValue  | money }}
                                            </strong>
                                            <small class="grey--text text--darken-1">
                                                Cobrança Total
                                            </small>
                                        </div>
                                        <div v-if="differenceValue >= 0" class="py-1 d-flex flex-column">
                                            <strong :class="['text-h4', differenceValue > 0 ? 'red--text': 'grey--text text--darken-1']">
                                                {{ differenceValue  | money }}
                                            </strong>
                                            <small class="grey--text text--darken-1">
                                                Valor Pendente
                                            </small>
                                        </div>
                                        <div v-else class="py-1 d-flex flex-column">
                                            
                                            <v-alert 
                                                v-if="totalPayment > totalValue" 
                                                dense
                                                dark
                                                type="error"
                                            >
                                                Atenção! Os meios de pagamento "Maquininha" e "Aplicativo" não permitem valores excedentes à cobrança total.
                                            </v-alert>
                                            <div v-else class="py-1 d-flex flex-column">
                                                <strong class="text-h4 green--text">
                                                    {{ changeValue  | money }}
                                                </strong>
                                                <small class="grey--text text--darken-1">
                                                    Valor de Troco
                                                </small>
                                            </div>
                                        </div>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" class="py-1 d-flex flex-column justify-space-between">
                                    
                                    <div class="d-flex">
                                        <strong class="px-1" v-if="lyndusPayMach != 0"><v-icon small>mdi-credit-card-outline</v-icon> {{ lyndusPayMach  | money }}</strong>
                                        <span v-if="lyndusPayMach != 0 && lyndusPayApp != 0 || lyndusPayMach != 0 && cashPay != 0">+</span>
                                        <strong v-if="lyndusPayApp != 0" class="px-1"><v-icon small>mdi-cellphone</v-icon> {{ lyndusPayApp  | money }}</strong>
                                        <span v-if="cashPay != 0 && lyndusPayApp != 0">+</span>
                                        <strong v-if="cashPay != 0" class="px-1"><v-icon small>mdi-cash</v-icon> {{ cashPay  | money }}</strong>
                                        <span v-if="lyndusPayMach != 0 && lyndusPayApp != 0 || lyndusPayMach != 0 && cashPay != 0 || lyndusPayApp != 0 && cashPay != 0">=</span>
                                    </div>
                                    <div class="py-1 d-flex flex-column">
                                        <strong class="text-h4">
                                            {{ totalPayment  | money }}
                                        </strong>
                                        <small class="grey--text text--darken-1">
                                            Valor do Pagamento
                                        </small>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-text v-else>
                        <v-container>
                            <v-row v-for="(payment, index) in payments " :key="index+'p'">
                                <v-col cols="12" sm="12" md="11">
                                    <v-row>
                                        <v-col
                                            cols="12"
                                            sm="12"
                                            md="7"
                                        >
                                            <v-select
                                                v-model="payment.paymentSelected"
                                                :items="filteredData"
                                                item-text="name"
                                                :return-object="true"
                                                label="Método de pagamento"
                                                placeholder="Escolha o método de pagamento"
                                                outlined
                                                dense
                                                required
                                                :rules="paymentRules"
                                            >
                                                <template v-slot:selection="{ item }">
                                                    {{ item.accountCategory }} - {{ item.name }} 
                                                </template>
                                                <template v-slot:item="{ item }">
                                                    {{ item.accountCategory }} - {{ item.name }}
                                                </template>
                                                
                                            </v-select>


                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="12"
                                            md="5"
                                        >
                                            <number-input
                                                outlined
                                                v-model="payment.value"
                                                :rules="textRules"
                                                label="Valor"
                                                placeholder="Valor"
                                                :options="optionsMoney"
                                                dense
                                            >
                                            </number-input>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" class="ma-0 py-0"
                                               v-show="payment.paymentSelected.bsAccountCategory == 1">
                                            <v-col cols="12" sm="12" md="12" class="ma-0 pa-0"
                                                   v-if="payment.paymentSelected.chavePIX">
                                                <b>ChavePIX:</b> {{ payment.paymentSelected.chavePIX }}
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" class="ma-0 pa-0" v-else>
                                                <b>ChavePIX:</b> {{ payment.paymentSelected.bankAccount }}
                                            </v-col>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" class="ma-0 py-0"
                                               v-show="payment.paymentSelected.bsAccountCategory == 2">
                                            <v-col cols="12" sm="12" md="12" class="ma-0 pa-0"
                                                   v-if="payment.paymentSelected.chavePIX">
                                                <b>ChavePIX:</b> {{ payment.paymentSelected.chavePIX }}
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" class="ma-0 pa-0" v-else>
                                                <b>Banco:</b> {{ payment.paymentSelected.bank }}
                                                &nbsp;<b>Agencia:</b> {{ payment.paymentSelected.agency }}
                                                &nbsp;<b>Conta:</b> {{ payment.paymentSelected.bankAccount }}
                                            </v-col>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12" class="ma-0 py-0"
                                               v-show="payment.paymentSelected.bsAccountCategory == 5">

                                            <!--                                    
                                            checkbox habilitar parcelamento
                                            exibir uma lista 1 / 24
                                            taxa de juros
                                            checkbox , cliente paga a taxa, ou taxa cobrada do cliente
                                            -->
                                            <v-col cols="12" sm="12" md="12" class="ma-0 pa-0 pb-1">
                                                <v-checkbox
                                                    v-model="payment.installment"
                                                    hide-details="true"
                                                    label="Pagamento Parcelado"
                                                    class="mt-1"
                                                ></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" class="ma-0 pa-0"
                                                   v-if="payment.installment">
                                                <v-row>
                                                    <v-col cols="12" sm="4" md="4" xs="12">
                                                        <v-select
                                                            v-model="payment.numberInstallment"
                                                            :items="installments"
                                                            label="N° Parcelas"
                                                            :rules="textRules"
                                                            outlined
                                                            dense
                                                        ></v-select>
                                                    </v-col>
                                                    <v-col cols="12" sm="4" md="4" xs="12">
                                                        <number-input
                                                            label="Taxa "
                                                            v-model.number=payment.fee
                                                            placeholder="Informe a taxa"
                                                            :options="optionsFee"
                                                            append-icon="mdi-percent"
                                                            :rules="textRules"
                                                            outlined
                                                            dense
                                                        ></number-input>
                                                    </v-col>
                                                    <v-col cols="12" sm="4" md="4" xs="12">
                                                        <v-checkbox
                                                            v-model=payment.clientFee
                                                            hide-details="true"
                                                            label="Taxa paga pelo cliente"
                                                            class="mt-1"
                                                        ></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-col>
                                    </v-row>
                                </v-col>

                                <v-col cols="12"
                                       sm="12"
                                       md="1">
                                    <v-btn icon small class="mt-2" @click="addPayment(index)" color="success"
                                           v-if="payments.length == index+1">
                                        <v-icon>mdi-plus-circle</v-icon>
                                    </v-btn>
                                    <v-btn icon small class="mt-2" @click="removePayment(index)" color="#FF3816"
                                           dark
                                           v-else>
                                        <v-icon>mdi-minus-circle</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" sm="12" md="12" class="ma-0 py-0">
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12" class="ma-0 py-0">
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="text-right py-1">
                                    Valor do Pagamento: {{ totalPayment  | money }}
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="text-right py-1">
                                    Valor Pendente: {{ differenceValue  | money }}
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="text-right py-1">
                                    Valor Total: {{ totalValue  | money }}
                                </v-col>

                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-divider class="mx-4"></v-divider>
                    <v-card-text>
                        <v-card-actions>
                                <v-btn
                                    color="#FF3816"
                                    dark
                                    @click="dialogPayment = false; resetPayment()"
                                >
                                    <v-icon left>mdi-close</v-icon>
                                    Cancelar
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="success"
                                    type="submit"
                                    :disabled="differenceValue > 0 || cashPay < changeValue"
                                >
                                    <v-icon left>mdi-content-save</v-icon>
                                    Salvar
                                </v-btn>
                        </v-card-actions>
                    </v-card-text>
                </v-form>
            </v-card>
        </v-dialog>

    </v-row>
</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";
import {mask} from "vue-the-mask";
import NumberInput from "@/components/NumberInput";


import {CHECKOUT_CHARGE, CHECKOUT_SCHEDULES_GET} from "@/store/actions/checkout.type";
import {
    CHECKOUT_RESET_STATE,
    SET_CHECKOUT_SCHEDULES_PAGINATION
} from "@/store/mutations/checkout.type";
import {PAYMENT_TYPES_GET} from "@/store/actions/schedule.type";
import {PERSON_GET} from "@/store/actions/person.type";


import {ACCOUNTS_LIST_GET} from "@/store/actions/financial.type";

export default {
    name: "checkout",
    directives: {mask},
    props: {
        source: String,
        id: {
            default: 0,
            type: Number,
            required: true
        }
    },

    components: {NumberInput},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        await Promise.all([
            store.dispatch(CHECKOUT_RESET_STATE),
            store.dispatch(PAYMENT_TYPES_GET),
            store.dispatch(ACCOUNTS_LIST_GET),
            store.dispatch(CHECKOUT_SCHEDULES_GET, to.params.id),
            store.dispatch(PERSON_GET, to.params.id)
        ]).then(() => {
            next();
        });
    },
    data: () => ({
        formato: { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' },
        installments: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
        //Lista de Usuários
        pagination: {
            sortBy: "name"
        },
        totalPayment: 0,
        totalValue: 0,
        differenceValue: 0,
        changeValue: 0,
        ativo: true,
        dialogPayment: false,
        payments: [
            {
                paymentSelected: {
                    id:28,
                    bsAccountCategory:7,
                    accountCategory:"Recebimento - LyndusPay",
                    name:"Maquininha",
                    bsAccountMovementID:null,
                    bsAccountMovementName:null,
                    fee:0.0,
                    cardMachine:"own",
                    valueMachine:0.0,
                    dayMachine:0,
                    installmentMachine:0,
                    cardCycle:"dynamic",
                    rescueDay:6,
                    closingDay:5,
                    receiptDay:6,
                    deleted:false,
                    active:true
                },
                value: null
            }
        ],
        paymentsMethods: [],
        btnPayDisabled: true,
        options: {},

        lyndusPayment: null,
        isNewPaymentMethods: true,
        lyndusPayMach: 0,
        lyndusPayApp: 0,
        cashPay: 0,

        selectedIDs: [],
        headers: [
            {
                text: "Pagamento",
                align: "left",
                value: "payment"
            },
            {
                text: "Data",
                align: "left",
                value: "date"
            },
            {text: "Profissional", value: "bmName"},
            {text: "Valor Total", value: "totalValue", sortable: false},
            {text: "Valor Pendente", value: "pendingValue", sortable: false},
            {text: "Status", value: "status", sortable: false},
            {text: "Ações", value: "actions", sortable: false}
        ],
        optionsFee: {
            locale: "pt-BR",
            prefix: "",
            length: 4,
            precision: 2,
        },
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        dateFormatted: null,
        menu1: false,
        menu2: false,

        formIsValid: false,

        textRules: [
            v => !!v || "Este campo é obrigatório"
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],
        paymentRules: [
            v => {
                if (typeof v === 'undefined') {
                    return "Este campo é obrigatório"
                }
                return !!v.id || "Este campo é obrigatório"
            }
        ],
        optionsMoney: {
            locale: "pt-BR",
            prefix: "R$:",
            length: 7,
            precision: 2
        },
    }),
    methods: {
        isMethod(bsAccountCategoryID) {
            return this.filteredData.find(({bsAccountCategory}) => bsAccountCategory === bsAccountCategoryID)
        },
        pushRouteToView(route) {
            this.$router.push({name: route});
        },
        resetPayment() {
            this.btnPayDisabled = true;
            this.totalValue = 0;
            this.selectedIDs = []
            this.$refs.formPayment.resetValidation();
            this.payments = [{
                paymentSelected: {},
                value: null
            }]
            this.lyndusPayMach = 0
            this.lyndusPayApp = 0
            this.cashPay = 0

        },
        checkBtnDisable() {
            if (this.selectedIDs.length) {
                this.btnPayDisabled = false
                return
            }
            this.btnPayDisabled = true
        },
        addPayment() {
            if (this.payments.length <= this.paymentTypes.length) {
                this.payments.push({paymentSelected: {}, value: null})
            }
        },
        addPaymentNew(method, value){
            const defaultIndex = this.payments.findIndex(item => item.value === null)
            if (defaultIndex !== -1) {
                this.removePayment(defaultIndex)
            }
            
            const index = this.payments.findIndex(item => item.paymentSelected.id === method.id)
            
            if (index !== -1) {
                this.payments[index].value = value
                if(value == 0){
                    this.removePayment(index)
                }
            } else if(value != 0) {
                this.payments.push({paymentSelected: method, value: value})
            }
            
        },
        removePayment(index) {
            if (this.payments.length > 1) {
                this.payments.splice(index, 1)
            }
        },
        payment() {
            this.totalValue = 0

            for (let i = 0; i < this.selectedIDs.length; i++) {
                for (let j = 0; j < this.checkoutSchedules.items.length; j++) {
                    if (this.checkoutSchedules.items[j].id == this.selectedIDs[i]) {
                        this.totalValue = this.totalValue + parseFloat(this.checkoutSchedules.items[j].pendingValue)
                    }
                }
            }

            this.totalValue = Math.round(this.totalValue * 100) / 100;
        },
        paymentSave() {

            if (this.$refs.formPayment.validate()) {

                for (let payment of this.payments){
                    if (payment.paymentSelected.id === 2){
                        payment.value = payment.value - this.changeValue
                    }
                }
                // this.inProgress = true
                let payData = {
                    id: this.id,
                    obj: {
                        ids: this.selectedIDs,
                        payments: this.payments
                    }
                }

                console.log("payData: ",payData)

                this.$store
                    .dispatch(CHECKOUT_CHARGE, payData)
                    .then(async () => {
                        this.inProgress = false;

                        this.snackbar.snackbar = true;
                        this.snackbar.color = "success";
                        this.snackbar.text = "Cobrança registrada com sucesso";
                        this.$refs.formPayment.resetValidation();

                        this.dialogItems = false;
                        this.dialogPayment = false;
                        this.checkBtnDisable()
                        this.resetPayment()
                        this.buscar();

                    })
                    .catch(({response}) => {
                        // this.dialogPayment = false;
                        this.inProgress = false;
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "error";
                        this.snackbar.text = "Erro ao salvar pagamentos.";
                        // console.log(response.data);
                        if (typeof response.data.message !== "undefined") {
                            this.snackbar.text =
                                "Erro: " +
                                response.data.message;
                        }
                    });
            } else {
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Preencha o formulário corretamente";
            }
        },
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },

        //Methods Lista Usuarios
        // toggleAll() {
        //     if (this.selected.length) this.selected = [];
        //     else this.selected = this.dados.slice();
        // },
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending;
            } else {
                this.pagination.sortBy = column;
                this.pagination.descending = false;
            }
        },
        buscar() {

            const {sortBy, sortDesc, itemsPerPage, page} = this.options
            // console.log(sortBy, sortDesc[0], itemsPerPage, page)

            store.commit(SET_CHECKOUT_SCHEDULES_PAGINATION, {
                page: page,
                itemsPerPage: itemsPerPage,
                orderBy: sortBy,
                sortDesc: sortDesc[0]
            })
            store.dispatch(CHECKOUT_SCHEDULES_GET, this.id);
        },

        reset() {
            this.$refs.formUsuario.reset();
        }
    },
    mounted() {
        this.dateFormatted = this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10))
    },
    watch: {
        payments:{
            handler: function (val) {
                console.log('payments', val)
                this.totalPayment = 0;
                for (let j = 0; j < val.length; j++) {
                    if(isNaN(parseFloat(val[j].value))){
                        continue
                    }
                    this.totalPayment = this.totalPayment + parseFloat(val[j].value);
                }
                let difference = this.totalValue - this.totalPayment
                // difference >= 0.0 ? this.differenceValue = difference: this.differenceValue = 0
                this.differenceValue = difference
                this.changeValue = Math.abs(difference)
            },
            deep: true  
        },
        options: {
            handler() {
                this.buscar()
            },
            deep: true,
        },
        date() {
            this.dateFormatted = this.formatDate(this.date)
        },
    },
    computed: {
        // ...mapState({
        //   courses: state => state.
        // })

        filteredData(){
            return this.listAccounts.filter(item => item.deleted === false)
        },

        ...mapGetters(["snackbar", "checkoutSchedules", "checkUsers", "checkoutSchedulesPagination", "person", "paymentTypes", "checkoutSchedule", "listAccounts"])
    },
};
</script>
